import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue, useSetFieldValue } from "formik";
import { useRecoilValue } from "recoil";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";
import { createSingleSectionInstanceInitialValues } from "../models/flexible/initial-values";
import { flexibleFormResponseState } from "../store/flexible";
import { isEmptyObject } from "../utils/is-empty-object";

export class TreatingPhysicianSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	useIsSectionOpenByDefault(): boolean {
		const [value] = useFieldValue(this.path);
		return !isEmptyObject(value);
	}

	useIsSectionOpenedConditionally(): boolean {
		return this.isAdverseEventsEnabled();
	}

	useIsSectionSwitchDisabled(): boolean {
		return this.isAdverseEventsEnabled();
	}

	useProcessSectionStateChange(): (isOpen: boolean) => void {
		const setFieldValue = useSetFieldValue();
		const initialData = useRecoilValue(flexibleFormResponseState);

		return (isOpen) => {
			if (isOpen) {
				setFieldValue(this.path, createSingleSectionInstanceInitialValues(this, {}, initialData));
				return;
			}

			setFieldValue(this.path, null);
		};
	}

	private isAdverseEventsEnabled(): boolean {
		const adverseEventsSection = this.context.sectionControllers.find((controller) =>
			controller.fieldControllers.some((field) => field.schema.attribute.identifier === AttributeIdentifiers.AdverseEvent)
		);

		if (!adverseEventsSection) {
			return false;
		}

		const [adverseEvents] = useFieldValue(adverseEventsSection.schema.localizableKey);
		return !!adverseEvents?.length;
	}
}
